export interface IShareLivePeople {
  id?: number;
  name?: string;
  idCard?: string;
  liveInfoId?: number;
}

export const defaultValue: Readonly<IShareLivePeople> = {};
